import {gql} from "@apollo/client";
import {Organization} from "@App/types";

export interface GaragesQuery {
    organization: Organization
}

export const GET_GARAGES = gql`
    query getGarages(
        $id: ID,
        $organization:ID!,
        $lat:Float,
        $lon:Float,
        $distance:Int,
        $appointmentsFrom: DateTimeTz,
        $appointmentsTo: DateTimeTz,
        $services: [ID],
        $search: String,
        $sortBy: String,
        $premiumServices: [ID],
        $slug: String,
        $offset: Int,
        $limit: Int,
        $brand: ID,
        $generation: ID,
        $motorization: ID,
        $gearbox: ID,
        $body: ID,
        $mileage: Int,
        $registrationDate: Date,
        $subRepairs: [String],
        $equipments: [String],
        $vcis: [String],
        $withTravelTime: Boolean,
        $withCalculation: Boolean!
        $onlyBookable: Boolean) {
        organization(id: $organization) {
            id
            calculation(
                input: {
                    services: $services
                    brand: $brand
                    generation: $generation
                    motorization: $motorization
                    mileage: $mileage
                    gearbox: $gearbox
                    body: $body
                    registration_date: $registrationDate
                    sub_repairs: $subRepairs
                    equipments: $equipments
                }
            )  @include(if: $withCalculation) {
                labour_steps {name}
                parts {name}
            }
            garages(
                id: $id,
                lat: $lat,
                lon: $lon,
                distance: $distance,
                appointmentsFrom: $appointmentsFrom,
                appointmentsTo: $appointmentsTo,
                search: $search,
                sortBy: $sortBy,
                services: $services,
                premiumServices: $premiumServices,
                slug: $slug,
                offset: $offset,
                limit: $limit,
                brand: $brand,
                withTravelTime: $withTravelTime,
                onlyBookable: $onlyBookable,
                vcis: $vcis,
                calculation: {
                    services: $services
                    brand: $brand
                    generation: $generation
                    motorization: $motorization
                    mileage: $mileage
                    gearbox: $gearbox
                    body: $body
                    registration_date: $registrationDate
                    sub_repairs: $subRepairs
                    equipments: $equipments
                }
            ){
                data {
                    id
                    name
                    slug
                    profileSlug
                    distance
                    lat
                    lon
                    rating
                    review_count
                    street
                    cover_image
                    cover_image_sizes {
                        name
                        path
                        media
                        width
                        height
                    }
                    description
                    images {
                        sizes {
                            name
                            path
                            media
                            width
                            height
                        }
                    }
                    opening_hours {
                        day
                        open
                    }
                    city
                    baseCity {
                        slug
                    }
                    postcode
                    supports_bev
                    phone
                    website
                    email
                    pivot {
                        bookable   
                        preferred_partner   
                    }
                    garageType {
                        name
                    }
                    nationwide_service
                    authorizedBrands {
                        id
                        name
                        icon
                    }
                    calculation @include(if: $withCalculation) {
                        estimated_price
                        estimated_price_before_promotion
                        parts_price
                        promotion {
                            description
                            gross_discount
                            formatted_discount_type
                            type
                            bonuses {
                                icon
                                name
                                description
                            }
                        }
                    }
                    available_days(services: $services) {
                        id
                        available_at
                    }
                    premium_services(services: $services) {
                        id
                        name
                    }
                    checkpoint {
                        id
                        name
                        logo
                    }
                    garageConcept {
                        id
                        name
                        logo
                    }
                }
                paginatorInfo {
                    hasMorePages
                }
            }
        }
    }
`;
